//商品タイプに応じたメッセージを設定
window.CustomDeliveryDatetime.settings.PRODUCT_IMAGES = {
    REMOTE_ISLAND:'',
    // 通常商品
    NORMAL:'',
    NORMAL_REGION:{ // 通常商品で都道府県ごとに画像を出したい場合は、以下に都道府県ID:画像URLで設定する
     //1:'https://cdn.shopify.com/s/files/1/0425/2005/1878/files/kessai.gif,
     //2:'https://cdn.shopify.com/s/files/1/0425/2005/1878/files/kessai.gif,
    },
    // 超大型商品
    LARGE:'',
    // 超大型配達
    LARGE_DELIVERY:'',
    // 超大型配送
    LARGE_SHIPPING:'',
    //【メーカー在庫有】
    MAKER:'',
    //【メーカー直送】【メーカー取り寄せ】
    MAKER_DIRECT:'',
    //予約商品
    RESERVATION:'',
    //在庫ぎれ
    OUT_OF_STOCK:'',
    FIXED_SHIPPING_DATE: '',
  };
  window.CustomDeliveryDatetime.settings.CART_IMAGES = {
    REMOTE_ISLAND:'',
    // 通常商品
    NORMAL:'',
    NORMAL_REGION:{},
    // 超大型商品
    LARGE:'',
    // 超大型配達
    LARGE_DELIVERY:'',
    // 超大型配送
    LARGE_SHIPPING:'',
    //【メーカー在庫有】
    MAKER:'',
    //【メーカー直送】【メーカー取り寄せ】
    MAKER_DIRECT:'',
    // 予約商品
    RESERVATION:'',
    // 在庫ぎれ
    OUT_OF_STOCK:'',
    // 
    FIXED_SHIPPING_DATE: '',
  };